import { translate } from '#packages/i18n';
import { notifications } from '#packages/stateManagement';
import { biLogger } from '#packages/util';
import constants from '#packages/constants';

import { TRANSLATIONS } from '../../../translations';
import { isHeaderOrFooter } from '../../../api';

import type { Scope } from '#packages/sections';
import type { EditorAPI } from '#packages/editorAPI';
import type { CannotRemovePlugin } from 'types/editorPlugins';
import type { CompRef } from 'types/documentServices';
import { clickOnGoToLayoutSettingsForHideHeaderAndFooterFeature } from '@wix/bi-logger-editor/v2';

const CUSTOM_MAIN_MENU_ID = 'CUSTOM_MAIN_MENU';

export const showCannotRemoveSiteSegmentNotification = (
  editorAPI: EditorAPI,
  compRef: CompRef,
) => {
  const isMobile = editorAPI.isMobileEditor();

  const currentPageId = editorAPI.pages.getCurrentPageId();
  const pagesData = editorAPI.pages.getPagesData();
  const { tpaApplicationId, managingAppDefId } = pagesData.find(
    ({ id: pageId }) => pageId === currentPageId,
  );
  const isTpaPage = Boolean(tpaApplicationId || managingAppDefId);

  const pagesMenu = editorAPI.dsRead.menu.getById(CUSTOM_MAIN_MENU_ID, false);
  const pagesMenuItems = editorAPI.menus.getExtendedMenuItemsTree(
    pagesMenu,
    pagesData,
  ).items;
  const isPageInMainMenu = pagesMenuItems.some(
    ({ pageData }: { pageData: AnyFixMe }) => pageData?.id === currentPageId,
  );

  if (isMobile && isTpaPage && !isPageInMainMenu) {
    return editorAPI.store.dispatch(
      notifications.actions.showUserActionNotification({
        message: translate(
          TRANSLATIONS.NOTIFICATIONS.CANNOT_REMOVE_SITE_SEGMENT_B.TEXT_MOBILE,
        ),
        type: 'info',
        shouldTranslate: false,
      }),
    );
  }

  return editorAPI.store.dispatch(
    notifications.actions.showUserActionNotification({
      message: translate(
        TRANSLATIONS.NOTIFICATIONS.CANNOT_REMOVE_SITE_SEGMENT_B.TEXT,
      ),
      type: 'info',
      shouldTranslate: false,
      link: {
        caption: translate(
          TRANSLATIONS.NOTIFICATIONS.CANNOT_REMOVE_SITE_SEGMENT_B.LINK,
        ),
        onNotificationLinkClick: () => {
          editorAPI.panelHelpers.openPagesPanel({
            ...(isMobile && isTpaPage && isPageInMainMenu
              ? { selectedTabId: CUSTOM_MAIN_MENU_ID }
              : {}),
            initialSettingsTabType: constants.PAGE_SETTINGS_TABS.LAYOUT,
          });

          const [params] = editorAPI.bi.getComponentsBIParams([compRef]);

          biLogger.report(
            clickOnGoToLayoutSettingsForHideHeaderAndFooterFeature({
              ...params,
              origin: 'delete notification',
            }),
          );
        },
      },
    }),
  );
};

export const createCannotRemoveSiteSegmentPlugin =
  (scope: Scope): CannotRemovePlugin =>
  (compRef) => {
    if (!isHeaderOrFooter(scope, compRef)) return;
    showCannotRemoveSiteSegmentNotification(scope.editorAPI, compRef);
  };
